import { Collection, Length, ModelBase, NormalLength, ObservableCollection, Property, Required, ShortLength, VeryShortString } from '@skylab-shared/core';
import { CustomFlags } from './../common/custom-flags';
import { ProductKind } from './product-kind';
import { ProductOssVatRateModel } from './product-oss-vat-rate.model';
import { ProductPriceModel } from './product-price.model';
import { ProductRelatedEInvoiceItemModel } from './product-related-e-invoice-item.model';

export class ProductModel extends ModelBase {
    @Property()
    public active: boolean;

    @Property({ identifiable: true })
    public id: number;

    @Property()
    public externalId: string;

    @Property()
    public offers: string[];

    @Property(String, {nullable: true})
    @Length({ max: ShortLength }, 'data-model.product.validation.cn-code.length')
    public cnCode: string | null;

    @Property(String, { nullable: true })
    @Length({ max: NormalLength }, 'data-model.product.validation.pkwiu.length')
    public pkwiu: string | null;

    @Property()
    public customFlags: CustomFlags;

    @Property()
    @Length({ max: 4000 }, 'data-model.product.validation.description.length')
    public description: string;

    @Property()
    public favourite: boolean;

    @Property()
    @VeryShortString('data-model.product.validation.fiscal-name.length')
    public fiscalName: string;

    @Property()
    public jpkVatGroups: string[];

    @Property()
    public kind: ProductKind;

    @Property()
    @Length({ max: 255 }, 'data-model.product.validation.name.length')
    @Required('data-model.product.validation.name.non-empty')
    public name: string;

    @Collection({ type: ProductPriceModel })
    public prices: ObservableCollection<ProductPriceModel>;

    @Collection({ type: ProductOssVatRateModel })
    public ossVatRates: ObservableCollection<ProductOssVatRateModel>;

    @Property(String, { nullable: true })
    public productGroupId?: string | null;

    @Property()
    public subjectToReverseCharge: boolean;

    @Property()
    public unitId: number;

    @Property()
    public vatRateId: number;

    @Property()
    public inventoryControl: boolean;

    @Property()
    public inventoryLevel: number;

    @Property({ nullable: true })
    public inventoryWarningLevel: number;

    @Property()
    public purchasePrice: ProductPriceModel;

    @Property({ nullable: true })
    public purchaseVatRateId: number;

    @Property({ nullable: true })
    @Length({ max: ShortLength }, 'data-model.product.validation.bar-code.length')
    public barCode: string;

    @Property({ nullable: true })
    @Required('data-model.product.validation.symbol.non-empty')
    @Length({ max: ShortLength }, 'data-model.product.validation.symbol.length')
    public symbol: string;

    @Collection({ type: ProductRelatedEInvoiceItemModel })
    public associatedEInvoiceSymbols: ObservableCollection<ProductRelatedEInvoiceItemModel>;
}
